import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { LocalizationService } from "./localization.service";
import {environment} from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(
    private http: HttpClient,
    private localizationService: LocalizationService
  ) {}


  getList<T>(endpoint: string, filter: any = {}): Observable<PaginatedResponse<T>> {
    let params = new HttpParams();

    params = params
      .set('page', filter.page || 1)
      .set('size', filter.size || 10);

    for (const key in filter) {
      if (filter[key] !== undefined && filter[key] !== null && key !== 'page' && key !== 'size') {
        if (Array.isArray(filter[key])) {
          filter[key].forEach((item: any) => {
            params = params.append(key, item);
          });
        } else {
          params = params.set(key, filter[key]);
        }
      }
    }

    return this.http.get<PaginatedResponse<T>>(
      `${environment.apiUrl}/${endpoint}`,
      { params }
    );
  }

  getOne<T>(endpoint: string, id: number | string): Observable<T> {
    return this.http.get<T>(`${environment.apiUrl}/${endpoint}/${id}`);
  }

  post<T>(endpoint: string, data: Partial<T>): Observable<T> {
    return this.http.post<T>(
      `${environment.apiUrl}/${endpoint}`,
      data,
      {
        params: {
          // lang: this.localizationService.getActiveLang()
        }
      }
    );
  }

  update<T>(endpoint: string, id: number | string, data: Partial<T>): Observable<T> {
    return this.http.put<T>(
      `${environment.apiUrl}/${endpoint}/${id}`,
      data,
      {
        params: {
          // lang: this.localizationService.getActiveLang()
        }
      }
    );
  }

  delete(endpoint: string, id: number | string): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/${endpoint}/${id}`);
  }

  downloadFile(endpoint: string, id: number | string): Observable<Blob> {
    return this.http.get(`${environment.apiUrl}/${endpoint}/${id}/download`, {
      responseType: 'blob'
    });
  }
}

interface PaginatedResponse<T> {
  items: T[];
  total: number;
  page: number;
  size: number;
}
